__turbopack_context__.v({
  "container": "index-module__rwLuka__container",
});
